<template>
    <div class="inner-container">
        <b-tab :id="'alt-tab-8'" :title="setText('settings.title')">
            <b-tabs class="tabs-in-tabs">
                <b-tab title="Блокировка" active>
                    <!-- фильтр -->
                    <div>
                        <div class="filter-container">
                            <div class="left-content">
                                <b-dropdown class="filter-dropdown overflow-visible" variant="default" ref="drop">
                                    <template #button-content>
                                        <span class="lc"><i class="icon icon-filter"></i> Фильтр </span><span class="rc"><i
                                        class="icon icon-keyboard"></i></span>
                                    </template>
                                    <div>
                                        <div class="top-content">
                                            <span>Параметры фильтра</span>
                                            <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                                        </div>
                                        <div class="sp-block-alteration">
                                            <!------------------ Region --------------------->
                                            <div class="filter-block">
                                                <b-form-group label="Регион">
                                                    <multiselect
                                                        v-model="block.region.selected"
                                                        :options="block.region.options"
                                                        :track-by="'code'"
                                                        :label="'label'"
                                                        placeholder="Выберите регион">
                                                    </multiselect>
                                                </b-form-group>
                                            </div>
                                            <!------------------ Type --------------------->
                                            <div class="filter-block">
                                                <b-form-group label="Регион">
                                                    <multiselect
                                                        v-model="block.type.selected"
                                                        :options="block.type.options"
                                                        :track-by="'code'"
                                                        :label="'label'"
                                                        placeholder="Признак">
                                                    </multiselect>
                                                </b-form-group>
                                            </div>
                                            <div class="filter-block">
                                                <b-button variant="secondary" @click="blockFilterClear">Сбросить</b-button>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>

                    <!-- модальное окно -->
                    <b-modal id="my-modal2"
                             ref="myModal2"
                             :title="getBlockModalTitle()"
                             hide-footer>

                        <div class="row">
                            <div class="col-md-3">
                                <label>Код:</label>
                            </div>
                            <div class="col-md-9" v-if="block.currentRegion">
                                <label>{{block.currentRegion.region}}</label>
                            </div>

                            <hr>

                            <div class="col-md-12">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="block.currentRegion.block">
                                    <label class="form-check-label">
                                        Блокировать создание заявок ГУ
                                    </label>
                                </div>
                                <br>
                            </div>
                            <div v-if="block.currentRegion.block">
                                <div class="col-md-12" v-if="block.currentRegion.type == 1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="block.currentRegion.form_4_20">
                                        <label class="form-check-label">
                                            Учитывать расхождения с 4-20
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <hr>
                                    <label class="form-check-label">
                                        Период блокировки
                                    </label>
                                </div>
                                <div class="col-md-12">
                                    <br>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="block.currentRegion.prev">
                                        <label class="form-check-label">Предыдущие месяцы</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="block.currentRegion.current">
                                        <label class="form-check-label">Текущий месяц</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="block.currentRegion.next">
                                        <label class="form-check-label">Последующие месяцы</label>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <button class="btn btn-secondary" @click="blockCloseModal">Отмена</button>
                                <button class="btn btn-primary" @click="saveBlock">Сохранить</button>
                            </div>
                        </div>
                    </b-modal>

                    <!-- Таблица -->
                    <div>
                        <div class="col-md-12">
                            <div class="container" style="height: calc(100vh - 200px); overflow-y: auto;">
                                <table class="table table-striped table-bordered" style="border-collapse: collapse; width: 100%;">
                                    <thead class="table-info" style="position: sticky; top: 0; bottom: 0;">
                                    <tr>
                                        <th v-for="(item, index) in block.tableCols"
                                            :key="'tableIndex' + index"
                                            :style="getBlockTableThStyle(item)"
                                            @click="setSortBlockCol(item.code)"><label>{{item.text}}</label></th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in filteredBlockList" :key="index">
                                        <td>{{ item.id }}</td>
                                        <td>{{getBlockRegion(item)}}</td>
                                        <td>{{ item.block }}</td>
                                        <td>{{ item.type }}</td>
                                        <td>{{ item.form_4_20 }}</td>
                                        <td>{{ item.prev }}</td>
                                        <td>{{ item.current }}</td>
                                        <td>{{ item.next }}</td>
                                        <td>{{ item.userName }}</td>
                                        <td> <button class="btn btn-outline-warning"
                                                     @click="selectBlock(item)"
                                                     v-b-modal.my-modal2><i class="icon icon-pencil-edit"/></button> </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab title="ФЛК">
                    <div>
                        <div class="filter-container">
                            <div class="left-content">
                                <b-dropdown class="filter-dropdown overflow-visible" variant="default" ref="drop">
                                    <template #button-content>
                                        <span class="lc"><i class="icon icon-filter"></i> Фильтр </span><span class="rc"><i
                                        class="icon icon-keyboard"></i></span>
                                    </template>
                                    <div>
                                        <div class="top-content">
                                            <span>Параметры фильтра</span>
                                            <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                                        </div>
                                        <div class="sp-block-alteration">
                                            <!------------------Level type--------------------->
                                            <div class="filter-block">
                                                <b-form-group label="Уровень">
                                                    <multiselect
                                                        v-model="flk.levelData.selected"
                                                        :options="flk.levelData.options"
                                                        :track-by="'code'"
                                                        :label="'name'"
                                                        placeholder="Выберите уровень">
                                                    </multiselect>
                                                </b-form-group>
                                            </div>
                                            <!------------------Request Type------------------------->
                                            <div class="filter-block">
                                                <b-form-group label="Тип бюджета">
                                                    <multiselect
                                                        v-model="flk.requestTypeData.selected"
                                                        :options="flk.requestTypeData.options"
                                                        :track-by="'code'"
                                                        :label="'name'"
                                                        placeholder="Выберите уровень">
                                                    </multiselect>
                                                </b-form-group>
                                            </div>
                                            <div class="filter-block">
                                                <b-button variant="secondary" @click="flkFilterClear">Сбросить</b-button>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>

                    <div class="filter-actions">
                        <div class="col-md-12">
                            <div>
                                <div class="col-md-12 text-right">
                                    <hr>
                                    <b-button variant="primary" @click="flkOpenModal()" v-b-modal.my-modal>Добавить</b-button>
                                </div>

                                <!-- модальное окно -->
                                <b-modal id="my-modal"
                                         ref="myModal"
                                         :title="getModalTitle()"
                                         hide-footer>

                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>тип ФЛК</label>
                                        </div>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="flk.currentFlk.flkType">
                                                <option selected :value="null">...</option>
                                                <option :value="1">1</option>
                                                <option :value="2">2</option>
                                                <option :value="3">3</option>
                                                <option :value="4">4</option>
                                                <option :value="6">6</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>Уровень</label>
                                        </div>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="flk.currentFlk.level">
                                                <option selected :value="null">...</option>
                                                <option v-for="item in flk.levelData.options" :value="item.code" :key="item.name">{{item.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>Тип запроса</label>
                                        </div>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="flk.currentFlk.requestType">
                                                <option selected :value="null">...</option>
                                                <option v-for="item in flk.requestTypeData.options" :value="item.code" :key="item.name">{{item.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>Класс</label>
                                        </div>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="flk.currentFlk.classType">
                                                <option selected :value="null">...</option>
                                                <option :value="1">1 - строгое</option>
                                                <option :value="2">2 - не строгое</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-md-12 text-right">
                                            <button class="btn btn-secondary" @click="flkCloseModal">Отмена</button>
                                            <button class="btn btn-primary" @click="saveCurrentFlk">Сохранить</button>
                                        </div>
                                    </div>
                                </b-modal>
                            </div>
                        </div>
                    </div>
                    <div style="height: calc(100vh - 200px); overflow-y: auto;">
                        <div class="col-md-12"  style="position: sticky; top: 0; bottom: 0;">
                            <div class="container">
                                <table class="table table-striped table-bordered" style="border-collapse: collapse; width: 100%;">
                                    <thead class="table-info">
                                    <tr>
                                        <th v-for="(item, index) in flk.tableCols"
                                            :key="'tableIndex' + index"
                                            :style="getTableThStyle(item)"
                                            @click="setSortCol(item.code)"><label>{{item.text}}</label></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in filteredFlkList" :key="index">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.flkType }}</td>
                                        <td>{{ getLevelName(item.level) }}</td>
                                        <td>{{ getRequestTypeName(item.requestType) }}</td>
                                        <td>{{ getClassName(item.classType) }}</td>
                                        <td>{{ millisToDate(item.updateDate) }}</td>
                                        <td> <button class="btn btn-outline-warning"
                                                     @click="selectFlk(item)"
                                                     v-b-modal.my-modal><i class="icon icon-pencil-edit"/></button> </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </b-tab>
            </b-tabs>
        </b-tab>
    </div>
</template>

<script lang="js">

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import alert from "@/components/c-icon/variants/alert";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";

export default {
    name: 'AlterationFlk',
    mixins: [ AlterationI18nMixin ],
    props: {
        userId: String,
        requestTypeOptions: Array,
    },
    computed: {
        filteredFlkList() {
            const filtered = this.flk.flkList.filter(item => {
                const levelMatch = !this.flk.levelData.selected || item.level === this.flk.levelData.selected.code;
                const requestTypeMatch = !this.flk.requestTypeData.selected || item.requestType === this.flk.requestTypeData.selected.code;
                return levelMatch && requestTypeMatch;
            });

            return [...filtered].sort((a, b) => {
                const col = this.flk.sort.col;
                const ask = this.flk.sort.ask;

                const valA = a[col];
                const valB = b[col];

                if (valA == null) return 1;
                if (valB == null) return -1;
                if (valA === valB) return 0;

                const result = valA > valB ? 1 : -1;
                return ask ? result : -result;
            });
        },
        filteredBlockList() {
            function createEmpty(region, type) {
                return {
                    id: null,
                    region,
                    block: false,
                    type,
                    form_4_20: false,
                    prev: false,
                    current: false,
                    next: false,
                    userId: null,
                    userName: null,
                    createDate: Date.now()
                };
            }
            const result = this.block.region.options.flatMap(region => {
                const found = this.block.data.filter(b => b.region === region.code);
                return [
                    found.find(b => b.type === 1) ?? createEmpty(region.code, 1),
                    found.find(b => b.type === 2) ?? createEmpty(region.code, 2)
                ];
            })
            const code = this.block.region.selected?.code;
            const type = this.block.type.selected?.code;
            return [...result]
                .filter(item => code == null || item.region === code)
                .filter(item => type == null || item.type === type)
                .sort((a, b) => {
                    const col = this.block.sort.col;
                    const ask = this.block.sort.ask;
                    const valA = a[col];
                    const valB = b[col];

                    if (valA == null) return 1;
                    if (valB == null) return -1;
                    if (valA === valB) return 0;

                    const result = valA > valB ? 1 : -1;
                    return ask ? result : -result;
                });
        },
        requestTypeMap() {
            return (this.requestTypeOptions || []).reduce((acc, item) => {
                acc[item.code] = item.name_ru;
                return acc;
            }, {});
        },
    },
    data() {
        return {
            user_uuid: this.$store.getters.user_uuid,
            flk: {
                tableCols: [
                    {
                        code: "id",
                        text: "#"
                    },
                    {
                        code: "flkType",
                        text: "тип ФЛК"
                    },
                    {
                        code: "level",
                        text: "Уровень"
                    },
                    {
                        code: "requestType",
                        text: "Тип запроса"
                    },
                    {
                        code: "classType",
                        text: "Класс"
                    },
                    {
                        code: "updateDate",
                        text: "Изменён"
                    },
                    {
                        code: "edit",
                        text: "..."
                    }
                ],
                sort: {
                    col: "id",
                    ask: true
                },
                currentFlk: {
                    id: null,
                    flkType: null,
                    requestType: null,
                    classType: null,
                    level: null,
                    createDate: null,
                    updateDate: null,
                },
                flkList: [{
                    "id": 0,
                    "flkType": 0,
                    "requestType": "",
                    "classType": 0,
                    "level": "",
                    "createDate": 0,
                    "updateDate": 0
                }],
                levelData: {
                    selected: null,
                    options: [
                        { code: 'gu', name: 'ГУ' },
                        { code: 'abp', name: 'АБП' },
                        { code: 'uf', name: 'УФ' }
                    ]
                },
                requestTypeData: {
                    selected: null,
                    options: [
                        { code: 'individual', name: 'Индивидуальная' },
                        { code: 'movement', name: 'Передвижка' },
                        { code: 'budget_adjustment', name: 'Корректировка бюджета' },
                        { code: 'budget_clarification', name: 'Уточнение бюджета' },
                        { code: 'budget_income', name: 'Поступления' },
                        { code: 'budget_income_movement', name: 'budget_income_movement' },
                        { code: 'budget_income_clarification', name: 'budget_income_clarification' }
                    ]
                }
            },
            block: {
                tableCols: [
                    {
                        code: "id",
                        text: "#"
                    },
                    {
                        code: "region",
                        text: "Регион"
                    },
                    {
                        code: "block",
                        text: "Блокировать"
                    },
                    {
                        code: "type",
                        text: "Тип"
                    },
                    {
                        code: "form_4_20",
                        text: "Форма 4-20"
                    },
                    {
                        code: "prev",
                        text: "Предыдущие"
                    },
                    {
                        code: "current",
                        text: "Текущий"
                    },
                    {
                        code: "next",
                        text: "Последующие"
                    },
                    {
                        code: "userName",
                        text: "Имя пользователя"
                    }
                ],
                sort: {
                    col: "id",
                    ask: true
                },
                region: {
                    selected: null,
                    options: []
                },
                type: {
                    selected: null,
                    options: [
                        {code: 1, label: "Расходы"},
                        {code: 2, label: "Доходы"},
                    ]
                },
                currentRegion: {
                    id: null,
                    region: null,
                    type: null,
                    block: null,
                    form_4_20: null,
                    prev: null,
                    current: null,
                    next: null,
                    userId: null,
                    userName: null,
                    createDate: null,
                },
                data: [],
            }
        }
    },
    watch: {
        "block.region.selected": function () {
            this.reloadBlock();
        },
        "block.type.selected": function () {
            this.reloadBlock();
        },
        "requestTypeOptions": function () {
            this.flk.requestTypeData.options = this.requestTypeOptions;
        }
    },
    async mounted() {
        await this.loadFlk();
        await this.loadRegions();
        await this.loadBlock();
    },
    methods: {
        async loadFlk() {
            const response = await fetch('/api/budget-execution-alteration-flk');
            if (!response.ok) throw console.log("error");
            const data = await response.json();
            this.flk.flkList = data;
        },
        async saveCurrentFlk() {
            const response = await fetch('/api/budget-execution-alteration-flk', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.flk.currentFlk)
            })
            if (!response.ok) throw console.log("error");
            this.flkCloseModal();
            await this.loadFlk();
        },
        getTableThStyle(col) {
            const baseStyle = {
                position: 'sticky',
                top: '0',
                zIndex: 2
            };
            if (col.code === this.flk.sort.col) {
                baseStyle.background = this.flk.sort.ask ? '#ddeeff' : '#c5d0e6';
            } else {
                baseStyle.background = '#d1ecf1';
            }
            return baseStyle;
        },
        setSortCol(colCode) {
            if (this.flk.sort.col === colCode) {
                this.flk.sort.ask = !this.flk.sort.ask;
            } else {
                this.flk.sort.col = colCode;
                this.flk.sort.ask = true;
            }
        },
        getTitle(field) {
            return "Исполнение бюджета"
        },
        getModalTitle() {
            if (!this.flk.currentFlk.id) return "Добавить ФЛК"
            else return "Редактировать ФЛК (id = " + this.flk.currentFlk.id + ")"
        },
        getRequestTypeName(level) {
            return this.requestTypeMap[level] || level;
        },
        getLevelName(level) {
            const levelMap = {
                gu: 'ГУ',
                abp: 'АБП',
                uf: 'УФ'
            };
            return levelMap[level] || level;
        },
        getClassName(classType) {
            const classMap = {
                1: '1 - строгое',
                2: '2 - не строгое'
            };
            return classMap[classType] || classType;
        },
        millisToDate(millis) {
            const date = new Date(millis)
            return date.toLocaleString('ru-RU');
        },
        flkFilterClear() {
            this.flk.levelData.selected = null;
            this.flk.requestTypeData.selected = null;
        },
        clearCurrentFlk() {
            this.flk.currentFlk = {
                id: null,
                flkType: null,
                requestType: null,
                classType: null,
                level: null,
                createDate: null,
                updateDate: null,
            }
        },
        flkOpenModal() {
            this.clearCurrentFlk()
        },
        flkCloseModal() {
            this.clearCurrentFlk()
            this.$refs.myModal.hide()
        },
        selectFlk(flk) {
            this.flk.currentFlk = JSON.parse(JSON.stringify(flk))
        },

        async loadRegions() {
            let listReg = null;
            const now = new Date();
            const startOfYear = new Date(now.getFullYear(), 0, 1).getTime();
            const endOfYear = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999).getTime();
            try {
                const response = await fetch(
                    `/api/budget-programs/budget_request_bp/budget_regions?user_uuid=${this.user_uuid}`
                );
                listReg = await response.json();
                listReg = listReg.filter(item => {
                    return !(item.begDate > endOfYear || item.endDate < startOfYear);
                });
                listReg.unshift({
                    "code": null,
                    "name_ru": "Все",
                    "name_kk": "Все"
                })
                this.block.region.options = listReg
                    .sort((a, b) => parseInt(a.code) - parseInt(b.code))
                this.block.region.options.forEach(item => item.label = item.code + ' - ' + item.name_ru)
            } catch (error) {
                alert("errors.region")
            }
        },
        reloadBlock() {
            if (this.block.region.selected == null || this.block.type.selected == null) {
                return
            }
            this.block.currentRegion = {
                id: null,
                region: this.block.region.selected
                    ? this.block.region.selected.code
                    : null,
                type: this.block.type.selected.code,
                block: null,
                form_4_20: null,
                prev: null,
                current: null,
                next: null,
                userId: null,
                userName: null,
                createDate: null,
            }
            if (this.block.region.selected) {
                const code = this.block.region.selected.code;
                const type = this.block.type.selected.code;
                const link = code
                    ? '/api/budget-execution-alteration-flk/block/region?code=' + code + '&type=' + type
                    : '/api/budget-execution-alteration-flk/block/region?type=' + type;

                fetch(link)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Ошибка HTTP: ${response.status}`);
                        }
                        if (response.headers.get('content-length') === '0') {
                            return null;
                        }
                        return response.json();
                    })
                    .then(data => {
                        if (data != null)
                            this.block.currentRegion = data
                    })
            }
        },
        async loadBlock() {
                fetch("/api/budget-execution-alteration-flk/block")
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Ошибка HTTP: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.block.data = data;
                    })
        },
        saveBlock() {
            // return
            fetch('/api/budget-execution-alteration-flk/block', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.block.currentRegion)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Ошибка HTTP: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    this.block.currentRegion = data;
                    this.loadBlock()
                    this.blockCloseModal()
                })
        },
        blockFilterClear() {
            this.block.region.selected = null;
            this.block.type.selected = null;
        },

        getBlockTableThStyle(col) {
            const baseStyle = {
                position: 'sticky',
                top: '0',
                zIndex: 2
            };
            if (col.code === this.block.sort.col) {
                baseStyle.background = this.block.sort.ask ? '#ddeeff' : '#c5d0e6';
            } else {
                baseStyle.background = '#d1ecf1';
            }
            return baseStyle;
        },
        setSortBlockCol(colCode) {
            if (this.block.sort.col === colCode) {
                this.block.sort.ask = !this.block.sort.ask;
            } else {
                this.block.sort.col = colCode;
                this.block.sort.ask = true;
            }
        },
        getBlockModalTitle() {
            return "Регион: " + this.block.region.options
                ?.find(x => x.code === this.block.currentRegion?.region)
                ?.name_ru;
        },
        blockCloseModal() {
            this.$refs.myModal2.hide()
        },
        selectBlock(block) {
            this.block.currentRegion = JSON.parse(JSON.stringify(block))
        },
        getBlockRegion(item) {
            return item.region ?? 'Все';
        }
    }
}
</script>